import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function SustainabilityPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    SUSTAINABILITY POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Commitment to Environmental and Social Responsibility
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Director: Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V10 – 2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL Employees Freelance Staff, and Learners</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Introduction */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK College recognises that sustainable development is the key to our social and environmental responsibility as well as our continued & future economic performance.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    We wholly embrace the ethos of sustainability and seek to promote, encourage, and nurture a sustainable environment/culture. We are committed to ensuring that we achieve this through:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '20px' }}>
                    <li>A holistic approach</li>
                    <li>Providing a safe, healthy sustainable working environment for staff, learners, and other stakeholders</li>
                    <li>Consistently encouraging staff and learners to acquire skills, values, and knowledge around sustainable development</li>
                    <li>Sharing best practice on sustainability within DTK College and the community we serve</li>
                    <li>Continuous improvement in our overall services</li>
                    <li>Communicating effectively to/through our stakeholders</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The College seeks to develop a policy framework that will look at sustainability issues from the point of view of three key areas: <em>Estate, the Curriculum, and the Community.</em> This will enable staff and learners to have a greater understanding of how we can contribute to the improvement of the environment we live in.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Estate */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. Estate
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The college aims to continue to promote best practice and environmentally friendly spaces:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li>Procurement – develop and regularly implement procurement strategy ensuring that practices reflect sustainability development</li>
                    <li>Promote sustainable travel – e.g., Walking, Car share, Cycle to Work where feasible</li>
                    <li>Promote and develop Energy Conservation strategies: control costs and consumption to maximise efficient use of resources</li>
                    <li>Develop waste management and recycling procedures in line with Newham Council policy.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Curriculum */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Curriculum
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The college offers a variety of curriculum programmes, and through this we aim to:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li>To encourage acceptance and delivery of further education for sustainable development (ESD)</li>
                    <li>To develop resources that can be used by staff and learners</li>
                    <li>To raise awareness of current issues and actions that the college should take in the development of suitable learning programmes</li>
                    <li>To promote individual and community responsibility for sustainability</li>
                    <li>To reduce waste in teaching materials.</li>
                    <li>To develop an awareness and understanding of the environment and the effects that human actions have upon it.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Local Community */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    3. Local Community
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As a college, we work with a wide range of stakeholders within the community. We aim to work creatively and innovatively to:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li>Promote community initiatives relating to Sustainable Development and awareness within the college</li>
                    <li>Continue to liaise with other partners to share best practice</li>
                    <li>Consistently seek opportunities to learn and improve</li>
                    <li>Provide leadership where necessary and be supportive of joint working with stakeholders.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default SustainabilityPolicy;